import $ from 'jquery';

const header = $('header.header-section');

$.fn.extend({
  toggleHtml: function (a, b) {
    return this.html(this.html() == b ? a : b);
  },
});

function fixedHeader(scrollBlock, header) {
  scrollBlock.on('scroll', function () {
    if (scrollBlock.scrollTop() > 100) {
      $('body').addClass('scrolled');
      header.addClass('scrolled');
    } else {
      $('body').removeClass('scrolled');
      header.removeClass('scrolled');
    }
  });
}
fixedHeader($(document), header);
